'use client';

import { captureException } from '../../../../../../../../services/sentry.service';

export function encodeJsonToBase64(json: object) {
  try {
    return btoa(JSON.stringify(json));
  } catch (error) {
    captureException(error, {
      extra: 'client util: encodeJsonToBase64',
    });
    return null;
  }
}

export function decodeBase64ToJson<T>(base64String: string): T | null {
  try {
    return JSON.parse(atob(base64String)) as T;
  } catch (error) {
    captureException(error, {
      extra: 'client util: decodeBase64ToJson',
    });
    return null;
  }
}
